export default __webpack_public_path__ + "static/media/leftSplash.cadbae86.gif";